<template>
  <button
    type="button"
    :class="buttonClass"
    v-bind="$attrs"
    v-on="$listeners"
    @mouseover="handleMouseEnter"
    @mouseout="handleMouseLeave"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    rounded: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      isHover: false,
    }
  },
  computed: {
    buttonClass () {
      return [this.$style.button, {
        [this.$style.button_hover]: this.isHover,
        [this.$style.button_circle]: this.rounded,
        [this.$style.button_active]: this.active,
      }]
    },
  },
  methods: {
    handleMouseEnter (event) {
      this.isHover = true
    },
    handleMouseLeave (event) {
      this.isHover = false
    },
  },
}
</script>

<style lang="scss" module>
.button {
  @apply rounded;
  @apply p-2;
  @apply border-0;
  @apply relative;
  background-color: #ef9c57;
  color: white;
  @apply fill-current;
  @apply cursor-pointer;
  transition: all .3s;
  @apply leading-none;

  &:focus,
  &:active {
    @apply outline-none;
  }

  &:active {
    transform: scale(0.93);
  }

  &::after {
    content: '';
    @apply absolute;
    @apply inset-0;
    @apply rounded;
    opacity: 0;
    transition: all .2s;
    box-shadow: inset 0px 0px 5px 3px rgba(0,0,0,0.15);
  }

  &:active::after {
    opacity: 1;
  }
}

.button_circle {
  @apply rounded-full;

  &::after {
    @apply rounded-full;
  }
}

.button_hover {
  background-color: #d78a4a;
}

.button[disabled] {
  background-color: #F2C5A0;
  @apply cursor-not-allowed;
}

.button_active {
  background-color: darken(#d78a4a, 7%);
}
</style>
